import { render } from "./ProjectTodoList.vue?vue&type=template&id=64abdc48&scoped=true"
import script from "./ProjectTodoList.vue?vue&type=script&lang=js"
export * from "./ProjectTodoList.vue?vue&type=script&lang=js"

import "./ProjectTodoList.vue?vue&type=style&index=0&id=64abdc48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64abdc48"]])

export default __exports__